export interface ITeamData {
    /** TeamId Guid */
    id: string;
    /** Team Name */
    name: string;
    /** ProjectId Guid */
    projectId?: string;
}